/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedAvailabilityScheduleUpdateRequest { 
    endDate?: string | null;
    weekInterval?: number;
    availabilityMode?: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    fromTime?: string;
    toTime?: string;
    startDate?: string;
    ignoreWarnings?: boolean;
}
export namespace PatchedAvailabilityScheduleUpdateRequest {
}

export const PatchedAvailabilityScheduleUpdateRequest_endDate_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_weekInterval_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(8),];

export const PatchedAvailabilityScheduleUpdateRequest_availabilityMode_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_fromTime_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_toTime_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_startDate_Validators: ValidatorFn[] =
    [ ];

export const PatchedAvailabilityScheduleUpdateRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


